<template>
  <el-dialog
    :title="'IP绑定 - ' + nickname"
    :visible="visible"
    width="640px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" label-width="82px">
      <el-form-item label="登录IP:">
        <el-input
          :rows="3"
          clearable
          type="textarea"
          :maxlength="1000"
          v-model.trim="form.login_ip_str"
          placeholder="请输入" />
      </el-form-item>
      <el-form-item label="请求IP:">
        <el-input
          :rows="3"
          clearable
          type="textarea"
          :maxlength="1000"
          v-model.trim="form.jk_ip_str"
          placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserIpDialog',
  props: {
    visible: Boolean,
    user: Object
  },
  data() {
    return {
      loading: false,
      form: {
        id: 0,
        login_ip_str: '',
        jk_ip_str: ''
      }
    };
  },
  computed: {
    nickname() {
      if (!this.user) {
        return '';
      }
      return this.user.realname || this.user.username;
    }
  },
  watch: {
    visible(val) {
      if (!val || !this.user) {
        return;
      }
      this.form = {
        id: this.user.id,
        login_ip_str: this.user.login_ip_str,
        jk_ip_str: this.user.jk_ip_str
      };
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    save() {
      if (!this.form.id) {
        this.$message.warning('商户信息无效');
        return;
      }
      this.loading = true;
      this.$http
        .post('/user/edit', {
          id: this.form.id,
          login_ip_str: this.form.login_ip_str,
          jk_ip_str: this.form.jk_ip_str
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
            return;
          }
          this.$message.error(res.data.msg || '保存失败');
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    }
  }
};
</script>
